import React, { useState, useEffect } from "react";
import { FaUsers } from "react-icons/fa";
import axios from "axios";
import ContactManagement from "./ContactManagement";
import QueryManagement from "../QueryManagement/QueryManagement";
import WebinarManagement from "../WebinarManagement/WebinarManagement";
import LeadManagement from "../LeadManagement/LeadManagement";
import PageLayout from "../../components/ui/PageLayout";
import PageHeader from "../../components/ui/PageHeader";
import { PillTabs } from "../../components/ui/TabBar";

const ContactsHub = () => {
  const [activeTab, setActiveTab] = useState("forms");
  const [counts, setCounts] = useState({
    forms: 0,
    queries: 0,
    webinar: 0,
    leads: 0,
  });

  useEffect(() => {
    const fetchAllCounts = async () => {
      const token = localStorage.getItem("adminToken");
      const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
      
      try {
        const [formsRes, queriesRes, webinarRes, leadsRes] = await Promise.all([
          axios.get(`${baseUrl}/api/contact/admin/all`, {
            headers: { Authorization: `Bearer ${token}` }
          }).catch(() => ({ data: { success: false } })),
          axios.get(`${baseUrl}/api/contact/admin/queries`, {
            headers: { Authorization: `Bearer ${token}` }
          }).catch(() => ({ data: { success: false } })),
          axios.get(`${baseUrl}/api/webinar/admin/all`, {
            headers: { Authorization: `Bearer ${token}` }
          }).catch(() => ({ data: { success: false } })),
          axios.get(`${baseUrl}/api/leads`, {
            headers: { Authorization: `Bearer ${token}` }
          }).catch(() => ({ data: { success: false } }))
        ]);

        setCounts({
          forms: formsRes.data.success ? formsRes.data.data.length : 0,
          queries: queriesRes.data.success ? queriesRes.data.data.length : 0,
          webinar: webinarRes.data.success ? webinarRes.data.data.length : 0,
          leads: leadsRes.data.success ? leadsRes.data.data.length : 0
        });
      } catch (error) {
        console.error("Failed to fetch initial contact counts:", error);
      }
    };

    fetchAllCounts();
  }, []);

  const handleCountChange = (tabId, count) => {
    setCounts(prev => ({ ...prev, [tabId]: count }));
  };

  const tabs = [
    { id: "forms", label: "Contact Forms", badge: counts.forms },
    { id: "queries", label: "Queries", badge: counts.queries },
    { id: "webinar", label: "Webinar Form", badge: counts.webinar },
    { id: "leads", label: "Landing Leads", badge: counts.leads },
  ];

  return (
    <PageLayout>
      <PageHeader
        title="Contacts Hub"
        description="Manage contact forms, queries, webinar registrations, and landing leads"
        icon={FaUsers}
        iconGradient="from-primary-500 to-primary-600"
      />

      <PillTabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />

      <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-card border border-gray-100 dark:border-dark-700 overflow-hidden">
        {activeTab === "forms" && <ContactManagement onCountChange={(count) => handleCountChange("forms", count)} />}
        {activeTab === "queries" && <QueryManagement onCountChange={(count) => handleCountChange("queries", count)} />}
        {activeTab === "webinar" && <WebinarManagement onCountChange={(count) => handleCountChange("webinar", count)} />}
        {activeTab === "leads" && <LeadManagement onCountChange={(count) => handleCountChange("leads", count)} />}
      </div>
    </PageLayout>
  );
};

export default ContactsHub;
